<template>
  <div style="flex: 1">
    <div class="d-flex funnel-filter">
      <div class="form-group">
        <DropdownCheckbox
          v-model="sourceFilterDataModel"
          :options="getSourceList"
          @input="handleSources"
          name="chart-two"
          label="description"
          placeholder="Source"
        />
      </div>

      <div class="form-group">
        <DropdownCheckbox
          v-model="stageFilterDataModel"
          :options="setoptions"
          @input="handleStages"
          name="funnel-one"
          placeholder="Stage"
          label="stage"
        />
      </div>

      <div class="form-group">
        <TimeRange
          name="chart-two-time-range"
          @input="handleTimeRangeFilter"
          v-model="timeRangeDataModel"
        />
        <!-- <TimeRange @time-range-change="handleTimeRangeFilter" /> -->
      </div>
    </div>

    <LineChartRecruiters
      :key="key"
      :chartPropData="getChartTwoData"
      v-if="getChartTwoData.length"
      :style="myStyles"
    />

    <div class="spinner-container text-center" v-if="isLoading">
      <svgHelper v-show="isLoading" name="loadingSpinner" class="ml-auto justify-items-center" />
    </div>
  </div>
</template>

<script>
import LineChartRecruiters from '@/components/Admin/Dashboard/Charts/LineChartTwo';
import TimeRange from '@/components/common/TimeRange/TimeRange';
import DropdownCheckbox from '@/components/common/DropdownCheckbox/DropdownCheckbox';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    LineChartRecruiters,
    TimeRange,
    DropdownCheckbox,
  },
  data: () => ({
    sourceFilterDataModel: [],
    stageFilterDataModel: [],
    timeRangeDataModel: { value: 'all_time', option: 'All time' },
    selectedSources: [],
    selectedStages: [],

    chartData: [],
    sourcesOptions: [],
    key: 0,
    isLoading: false,
    timeRange: [{ value: 'all_time', option: 'all_time' }],
    myStyles: {
      position: 'relative',
      height: `${80}%`,
    },
    options: [],
    setoptions: [
      { id: 102, stage: 'Not contacted' },
      { id: 103, stage: 'Contacted' },
      { id: 104, stage: 'Interviewing' },
      { id: 106, stage: 'Offered employment' },
      { id: 107, stage: 'Employed' },
      { id: 108, stage: 'No longer interested' },
      { id: 109, stage: 'Not in consideration' },
    ],
    jobFilterDataModel: [],
  }),
  methods: {
    ...mapActions(['retrieveChartTwoData']),
    handleSources(sources) {
      this.options = this.setoptions;
      this.selectedSources = sources;
      this.fetchCharTwotData();
    },
    handleStages(stages) {
      this.selectedStages = stages;
      this.fetchCharTwotData();
    },
    handleTimeRangeFilter() {
      this.fetchCharTwotData();
    },

    fetchCharTwotData() {
      this.isLoading = true;

      this.retrieveChartTwoData({
        source_ids: this.sourceFilterDataModel.map((source) => source.id),
        stage_ids: this.stageFilterDataModel.map((stage) => stage.id),
        date: [this.timeRangeDataModel.value],
      })
        .then(() => {
          this.isLoading = false;
          this.key += 1;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    selectedStages(/* newVal, oldVal */) {
      // console.log(`old: ${oldVal} | new: ${newVal}`);
      //  localStorage.dashboardSelectedEmployer = this.selectedEmployer;
      //  localStorage.country = val.countryName;
      //this.selectedStages = [];
    },
    sourceFilterDataModel(newSelectedSource) {
      this.localStoragePlugin.set('chartTwoSourceSelect', newSelectedSource);
    },
    stageFilterDataModel(newSelectedStage) {
      this.localStoragePlugin.set('chartTwoStageSelect', JSON.stringify(newSelectedStage));
    },
    timeRangeDataModel(newSelectedTimeRange) {
      this.localStoragePlugin.set('chartTwoTimeRangeSelect', newSelectedTimeRange);
    },
  },
  computed: {
    ...mapGetters(['getChartTwoData', 'getSourceList']),
  },
  mounted() {
    if (this.localStoragePlugin.has('chartTwoSourceSelect')) {
      this.sourceFilterDataModel = this.localStoragePlugin.get('chartTwoSourceSelect');
    }

    if (this.localStoragePlugin.has('chartTwoStageSelect')) {
      this.stageFilterDataModel = this.localStoragePlugin.get('chartTwoStageSelect');
    }

    if (this.localStoragePlugin.has('chartTwoTimeRangeSelect')) {
      this.timeRangeDataModel = this.localStoragePlugin.get('chartTwoTimeRangeSelect');
    }

    this.retrieveChartTwoData({
      source_ids: this.sourceFilterDataModel.map((source) => source.id),
      stage_ids: this.stageFilterDataModel.map((stage) => stage.id),
      date: [this.timeRangeDataModel.value],
    })
      .then(() => {
        this.isLoading = false;
        this.key += 1;
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.funnel-filter {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  .form-control {
    width: 33%;
    flex-shrink: 0;
  }
  .form-group {
    width: 32.8%;
    flex-shrink: 0;
  }
  .dropdown-toggle {
    display: block;
    width: 100%;
  }
}
</style>
